import { createBrowserRouter, Navigate, type RouteObject } from 'react-router-dom';
import { ROUTE_PATHS } from '@/constants/common';
import { tasksRoute } from './modules/tasksRouter';
import { channelsRoute } from './modules/channelsRouter';
import { consumerPoolRoute } from './modules/consumerPoolRouter';
import { dashboardRoute } from './modules/dashboardRouter';

const routes: RouteObject[] = [
  {
    path: ROUTE_PATHS.login,
    lazy: async () => ({
      Component: (await import('@/pages/login')).default,
    }),
  },
  {
    path: '/',
    lazy: async () => ({
      Component: (await import('@/layouts')).default,
    }),
    children: [
      {
        index: true,
        element: <Navigate replace to={ROUTE_PATHS.dashboard} />,
      },
      dashboardRoute,
      tasksRoute,
      channelsRoute,
      consumerPoolRoute,
    ],
  },
  {
    path: '*',
    lazy: async () => ({
      Component: (await import('@/pages/not-found')).default,
    }),
  },
];

export const router = createBrowserRouter(routes, {
  // basename: import.meta.env.VITE_APP_BASE_URL,
  // 未来功能
  future: {
    v7_relativeSplatPath: true,
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_skipActionErrorRevalidation: true,
  },
});
